import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcEarth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.4802,
			cy: 12.4997,
			r: 7.42549,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3072 5.04829C21.2263 6.96746 22.3231 9.55183 22.3562 12.2329C22.3893 14.9139 21.356 17.472 19.4836 19.3444C17.6112 21.2167 15.0531 22.2501 12.3721 22.217C9.69103 22.1839 7.10667 21.0871 5.1875 19.168",
			stroke: "currentColor",
			strokeWidth: .896
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4219 6.55968L20.6495 4.33203",
			stroke: "currentColor",
			strokeWidth: .896
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.3125 20.6691L6.54015 18.4414",
			stroke: "currentColor",
			strokeWidth: .896
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7323 7.24938C18.4218 7.9389 18.9688 8.75748 19.342 9.65839C19.7151 10.5593 19.9072 11.5249 19.9072 12.5C19.9072 13.4751 19.7151 14.4407 19.342 15.3416C18.9688 16.2425 18.4218 17.0611 17.7323 17.7506C17.0428 18.4401 16.2242 18.9871 15.3233 19.3603C14.4224 19.7334 13.4568 19.9255 12.4817 19.9255C11.5066 19.9255 10.541 19.7334 9.64009 19.3603C8.73919 18.9871 7.92061 18.4401 7.23108 17.7506L12.4817 12.5L17.7323 7.24938Z",
			fill: "#B7D8F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 22.1562V24.7552",
			stroke: "currentColor",
			strokeWidth: .896
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1953 24.7539H10.2549",
			stroke: "currentColor",
			strokeWidth: .896
		})
	]
});
export default SvgIcEarth;
